import { jsx as _jsx } from "react/jsx-runtime";
import { useRangeRects } from "../hooks/useRangeRect.js";
const overlayStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 2147483645,
    pointerEvents: "none",
};
const bandStyle = (r) => ({
    position: "absolute",
    left: `${r.left}px`,
    top: `${r.top}px`,
    width: `${r.width}px`,
    height: `${r.height}px`,
    background: "rgb(99 102 241 / 0.28)",
    border: "1px solid rgb(129 140 248)",
    borderRadius: "3px",
});
export const TextRangeHighlighter = ({ range }) => {
    const rects = useRangeRects(range);
    if (rects.length === 0)
        return null;
    return (_jsx("div", { style: overlayStyle, "aria-hidden": true, children: rects.map((r, i) => (_jsx("div", { style: bandStyle(r) }, i))) }));
};
//# sourceMappingURL=TextRangeHighlighter.js.map